import React, { useRef } from "react";
import style from "./index.module.scss";
import { Button, message, Popover } from "antd";
import {
    activityBaseInfoItem,
    cancelGroupActivity
} from "../../../../../service/group";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import DeleteConfirm from "components/DeleteConfirm";
import { useSetAtom } from "jotai";
import { ActivityIdAtom, FlagAtom, PreviewAtom } from "../../store";
import useModalHandler from "../../../../../utils/v2/useModalHandler";
import CopyModal from "../../../CourseChapters/Index/Components/ApplyModal";
import EditEndTimeModal from "../EditEndTimeModal";
import SubmitError from "components/SubmitError";

interface ListDropDownProps {
    item: activityBaseInfoItem;
    updateList?: () => void; //更新列表
    onDelete: () => void; //删除
    onEdit: () => void; //编辑
}

export default function ListDropDown({
    item,
    updateList,
    onDelete,
    onEdit
}: ListDropDownProps) {
    const ref = useRef<HTMLDivElement>(null);
    const updateFlag = useSetAtom(FlagAtom);
    const updatePreview = useSetAtom(PreviewAtom);
    const setActivityId = useSetAtom(ActivityIdAtom); //活动id

    //查看
    const handlePreview = () => {
        updateFlag("edit");
        onEdit();
        setActivityId(item.id);
        updatePreview(true);
    };

    //取消发布
    const onCancelPublish = async () => {
        try {
            await cancelGroupActivity(item.id);
            await updateList?.();
            message.success("取消发布成功");
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="取消发布失败" content={errorMessage(e)} />,
                { width: 300 }
            );
        }
    };

    const editModal = useModalHandler(CopyModal);

    const onEditTime = (item: activityBaseInfoItem) => {
        editModal.setPayload(item);
        editModal.open();
    };
    const onEditOk = () => {
        editModal.close();
        updateList?.();
    };

    const popover = (
        <div className={style.popover}>
            <Button type="link" onClick={handlePreview}>
                查看
            </Button>
            <Button type="link" onClick={onDelete}>
                删除
            </Button>
            <DeleteConfirm
                title="确认取消发布小组活动吗？"
                content="取消发布后，学生将无法查看小组活动。"
                onSuccess={onCancelPublish}>
                <button>取消发布</button>
            </DeleteConfirm>
            <Button type="link" onClick={() => onEditTime(item)}>
                修改截止时间
            </Button>
        </div>
    );

    return (
        <div className={style.root} ref={ref}>
            <Popover
                content={popover}
                placement="bottom"
                overlayClassName={style.popoverWrapper}
                getPopupContainer={() => ref.current!}>
                <button className={style.more} />
            </Popover>

            {editModal.render(<EditEndTimeModal width={610} onOk={onEditOk} />)}
        </div>
    );
}
